<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu danh sách khai thác tài sản</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị quản lý:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" ref="unitTree" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="QĐ phê duyệt Đề án số:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.decisionNumber" placeholder="Nhập số quyết định"></b-form-input>
                                </b-form-group>

                            </b-col>
                        </b-row>

                        <b-row>

                            <b-col md="6">
                                <b-form-group label="Hình thức khai thác:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 placeholder="--- Tất cả ---"
                                             v-model="searchForm.exploitationType"
                                             :options="exploitationTypes" allowClear></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Số hợp đồng:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.contractNumber" placeholder="Nhập số hợp đồng"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="QĐ phê duyệt Đề án từ ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.decisionStartDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đến ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.decisionEndDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Khai thác - từ ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.startDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                                <b-form-group label="Ngày hợp đồng từ ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.contractStartDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đến ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.endDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                                <b-form-group label="Đến ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.contractEndDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center">
                            <b-col md="6">
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="data/asset-exploitation-decisions"
                            gridName="Danh sách khai thác tài sản"
                            ref="assetExploitationDecision">
                        <!--<template v-slot:actions v-if="hasDeletePermission && isAdmin">
                            <b-button size="md" @click.stop="removeSelected" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>
                        </template>-->
                        <template v-slot:cell(exploitationType)="row">
                            {{ exploitationTypes[row.item.exploitationType - 1] != undefined ? exploitationTypes[row.item.exploitationType - 1].text : "" }}
                        </template>
                        <template v-slot:cell(decisionDate)="row">
                            {{ row.item.decisionDate | formatDate }}
                        </template>
                        <template v-slot:cell(startDate)="row">
                            {{ row.item.startDate | formatDate }} - {{ row.item.endDate | formatDate }}
                        </template>
                        <template v-slot:cell(contractDate)="row">
                            {{ row.item.contractDate | formatDate }}
                        </template>
                        <template v-slot:cell(expectedValue)="row">
                            {{ row.item.expectedValue | currency }}
                        </template>
                        <template v-slot:cell(notes)="row">
                            <div style="width: 110%">{{ row.item.notes }}</div>

                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewAssetExploitationDecision'])" size="sm" :to="{ path: `./${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button v-if="hasDeletePermission && isAdmin" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    export default {
        name: 'ListAssetExploitationDecisions',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    decisionNumber: null,
                    decisionStartDate: null,
                    decisionEndDate: new Date().formatDate(),
                    exploitationType: null,
                    contractNumber: null,
                    startDate: null,
                    endDate: new Date().formatDate(),
                    contractStartDate: null,
                    contractEndDate: new Date().formatDate(),
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                },
                exploitationTypes: [
                    { id: 1, text: 'Cho thuê' },
                    { id: 2, text: 'Kinh doanh' },
                    { id: 3, text: 'Liên doanh, liên kết' },
                    { id: 4, text: 'Khác' }
                ],
                gridOptions: {
                    fields: [
                        { key: 'decisionNumber', label: 'QĐ phê duyệt Đề án số', sortable: true, sortDirection: 'asc' },
                        { key: 'decisionDate', label: 'QĐ phê duyệt Đề án ngày', sortable: true, sortDirection: 'asc' },
                        { key: 'startDate', label: 'Ngày khai thác', sortable: true, sortDirection: 'asc' },
                        { key: 'exploitationType', label: 'Hình thức khai thác', sortable: true, sortDirection: 'asc' },
                        { key: 'unitName', label: 'Đơn vị quản lý', sortable: true, sortDirection: 'asc' },
                        { key: 'contractNumber', label: 'Số hợp đồng', sortable: true, sortDirection: 'asc' },
                        { key: 'contractDate', label: 'Ngày hợp đồng', sortable: true, sortDirection: 'asc' },
                        { key: 'partnerName', label: 'Đối tác', sortable: true, sortDirection: 'asc' },
                        { key: 'expectedValue', label: 'Giá trị hợp đồng', sortable: true, tdClass: 'text-right', tdAttr: (key, value, item) => ({ title: item.expectedValue }) },
                        { key: 'contractContent', label: 'Nội dung', sortable: false, tdAttr: (key, value, item) => ({ title: item.contractContent }) },
                        { key: 'notes', label: 'Ghi chú', sortable: false, tdAttr: (key, value, item) => ({ title: item.notes }) },
                    ],
                    sortBy: 'decisionNumber',
                },
                isShowBtnDelete: true
            }
        },
        computed: {
            hasDeletePermission() {
                return this.authorize(['ManageAssetExploitationDecision']);
            }
        },
        created() {
            //this.searchForm.unitId = this.$store.state.identity.unitId || 1;
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.assetExploitationDecision.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.assetExploitationDecision.refresh();
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.assetExploitationDecision.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các quyết định này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/asset-exploitation-decisions?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các quyết định thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn quyết định cần xóa');
                }
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa khai thác tài sản này?')) {
                    this.$services.delete(`data/asset-exploitation-decisions/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa khai thác tài sản thành công');
                        vm.search();
                    });
                }
            },
        }
    }
</script>
<style scoped>
    .w30 {
        width: 30px;
    }
</style>
